__turbopack_context__.v({
  "forgotPasswordModal": "ForgotPasswordModal-module__BAYhAW__forgotPasswordModal",
  "h3": "ForgotPasswordModal-module__BAYhAW__h3",
  "h6": "ForgotPasswordModal-module__BAYhAW__h6",
  "input": "ForgotPasswordModal-module__BAYhAW__input",
  "inputContainer": "ForgotPasswordModal-module__BAYhAW__inputContainer",
  "submitButton": "ForgotPasswordModal-module__BAYhAW__submitButton",
  "toastContainer": "ForgotPasswordModal-module__BAYhAW__toastContainer",
});
